<template>
  <div class="detail-title clearfix" :style="isHaveBg ? bgColor : ''">
    <h2>{{title}}</h2>
    <em v-if="isShowCopy" @click="copyData"><img src="@/assets/images/common/icon_copy.png"/></em>
    <span class="dtinfo" v-if="info">{{info}}</span>
    <div style="float:right;">
      <Button style="text-align: center;" v-if="showButton1" @click="buttonOpt1">
        {{buttonInfo1}}
      </Button>
      <Button style="text-align: center;margin-left: 10px;" v-if="showButton" @click="buttonOpt">{{buttonInfo}}</Button>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      title: String,
      info: String,
      isShowCopy: Boolean,
      type: Number,
      buttonInfo: String,
      showButton: Boolean,
      buttonInfo1: String,
      showButton1: Boolean,
      isHaveBg: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        bgColor: 'background-color: rgba(248, 248, 249, 1);'
      }
    },
    methods: {
      copyData() {
        if (this.type === 0) {
          this.$bus.$emit("copy2SellerData", true);
        } else {
          this.$bus.$emit("copy2SecSellerData", true);
        }
      },
      buttonOpt() {
        this.$emit('buttonOption')
      },
      buttonOpt1() {
        this.$emit('buttonOption1')
      }
    }
  };
</script>

<style>
  .detail-title {
    height: 48px;
    line-height: 36px;
    position: relative;
    padding-top: 12px;
    box-sizing: border-box;
  }

  .detail-title h2 {
    float: left;
    color: #17233d;
    font-size: 14px;
    text-indent: 10px;
  }

  .detail-title em {
    cursor: pointer;
    margin: 5px 0 0 10px;
  }

  .dtinfo {
    float: right;
    font-size: 14px;
    color: #808695;
    padding-right: 10px;
  }
</style>